module.exports = __webpack_public_path__ + "static/media/gokrisp-features.c261e8f1.jpg";